<template>
    <div class="card card-modern pt-3" style="border: none; box-shadow: none;">
        <div class="modern-header" style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
            <div style="display: flex; align-items: center; gap: 15px;">
                <div class="header-icon" style="background: #fff7ed; color: #ff9800; width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center;">
                    <i class="material-icons" style="font-size: 24px; margin: 0;">description</i>
                </div>
                <h4 class="card-title" style="margin: 0; font-size: 1.5rem; color: #1e293b;">{{ title }}</h4>
            </div>
            <a v-if="modeloUrl" :href="modeloUrl" target="_blank" class="btn btn-solar-secondary" style="margin: 0;">
                <i class="material-icons">file_download</i> Baixar Modelo
            </a>
        </div>
        <div class="card-body">
            <div
                style="border: 2px dashed #ff9800; border-radius: 16px; background-color: #fff7ed; height: 250px; display: flex; cursor: pointer; transition: all 0.3s ease;"
                @click="$refs.input.click()"
                @drop="$event.preventDefault();arquivos($event.dataTransfer.files);"
                @dragover="$event.preventDefault()" >
                <div style="margin: auto">
                    <div style="display: flex; height: 100%" v-if="uploading">
                        <div class="lds-spinner" style="margin: auto">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                    <div v-else>
                        <h4 v-if="file" style="text-align: center">{{ file }}</h4>
                        <h5 v-else style="text-align: center">Formatos .XLSX, .XLS, .CSV, .ODS</h5>
                    </div>
                </div>
            </div>

            <input ref="input" type="file" style="display: none" @change="$event.preventDefault(); arquivos($event.target.files);" />

            <div v-show="success" class="mt-3" style="margin: auto;">
                <span style="font-weight: bold; margin: auto;">Importação concluída com sucesso!</span>
            </div>

            <div v-show="errors" class="mt-3">
                <ul>
                    <li v-for="(error, i) in errors" :key="i">
                        <span style="font-weight: bold; color: red;">{{ error }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        success: Boolean,
        errors: Array,
        uploading: Boolean,
        modeloUrl: String
    },
    data() {
        return {
            file: null
        }
    },
    methods: {
        arquivos(e) {
            this.file = e[0].name;
            this.toJson(e[0], (data) => {
                this.$emit('dados', data);
            });
        },
        toJson(file, call) {
            var reader = new FileReader();

            reader.onload = function (e) {
                var data = e.target.result;
                var json = PLANILHA.json(data);
                call(json);
            };

            reader.readAsBinaryString(file);
        },
    },
};
</script>